import {Component, EventEmitter, Input, OnInit, Output, OnChanges} from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TypesService} from '../../../services';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {DataHandlerService} from '../../../services/data-handler.service';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgIf, NgFor } from '@angular/common';
import {
  AbnSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/abn-search/abn-search.component';

export interface BorrowerTypeInfo {
  borrowingType: any;
  borrowerCount: number;
}

@Component({
    selector: 'app-borrower-type',
    templateUrl: 'borrower-type.component.html',
    standalone: true,
    imports: [NgIf, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule,
      MatSelectModule, MatSelectModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent, AbnSearchComponent]
})
export class BorrowerTypeComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isPersonalLoan = true; // true if personal, false if business, null if display all
  @Input() public selectedCompany: any;
  @Input() public isLateInit = false; // if form is loaded via partial, don't emit borrower type changes
  @Input() public personList: UntypedFormArray; // true if personal, false if business, null if display all
  @Output() public borrowingTypeChange = new EventEmitter<BorrowerTypeInfo>();
  @Output() public selectedTrustCompany = new EventEmitter<any>();

  public borrowingTypeSlug = 'borrowing-types-v2';
  public borrowingTypes = [];
  public borrowerCountRequired = false;
  public selectedType = null;
  public countLabel: string;
  public showTrustACN = false;

  constructor(public dataHandlerService: DataHandlerService,
              private typesService: TypesService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.formGroup.get('borrowerType').valueChanges.subscribe(val => {
      console.debug('BorrowerTypeComponent.borrowerType.valueChanges');
      this.setBorrowerCountTriggers(val);
      this.dataHandlerService.sendMainBorrowerType(val);
      this.emitBorrowerTypeChange(this.selectedType, this.formGroup.value.borrowerCount);
    });

    this.formGroup.get('borrowerCount').valueChanges.subscribe(val => {
      console.debug('BorrowerTypeComponent.borrowerCount.valueChanges');
      this.emitBorrowerTypeChange(this.selectedType, val);
    });

    this.dataHandlerService.sendMainBorrowerType(this.formGroup.get('borrowerType').value);
    this.populateBorrowingTypes();
  }

  ngOnChanges(changes) {
    console.log('borrower-type', changes);
    if (changes['selectedCompany'] && this.selectedCompany) {
      this.setBorrowingTypeFromAbn();
    }

    if (changes.isPersonalLoan &&
      (changes.isPersonalLoan.previousValue !== changes.isPersonalLoan.currentValue)) {
      this.populateBorrowingTypes();

    }
  }

  public populateBorrowingTypes() {
    this.typesService.getTypesList(this.borrowingTypeSlug).then((res) => {
      console.log('[borrowingTypes]', this.borrowingTypes);
      this.selectedType = this.borrowingTypes.find((type) => this.formGroup.value.borrowerType === type.id);
      this.borrowingTypes = res
        .filter(type => {
          if (this.isPersonalLoan !== true && this.isPersonalLoan !== false) { // if personal is undefined
            return true;
          }
          if (!type.ext.personal) { // handle if null or undefined
            type.ext.personal = false;
          }
          return type.ext.personal === this.isPersonalLoan;
        });

      if (this.formGroup.get('borrowerType').value) {
        // if option is no longer valid, reset the borrower type value
        if (!this.borrowingTypes.find(t => this.formGroup.value.borrowerType === t.id)) {
          this.formGroup.get('borrowerType').reset();
        }

        if (this.formGroup.value.borrowerType === 'joint-individual') {
          this.setBorrowerCountTriggers(this.formGroup.get('borrowerType').value);
        }
      }

      // ### DEVNOTE ###
      // disabling this part because it should have no default value.
      // reference: https://firstmac.atlassian.net/wiki/spaces/AW/pages/745308426/Personal+Car+Loan+Wizard+Broker+and+Internal
      // related HDR: https://firstmac.atlassian.net/browse/APPSUP-8944
      // // personal
      // if (this.isPersonalLoan && !this.formGroup.get('borrowerType').value) {
      //   // set to individual by default
      //   this.formGroup.get('borrowerType').patchValue('individual');
      // }
    });
  }

  public updateIndividualCount(value) {
    const individualCount = (value === 'joint-individual') ? 2 : 1;
    this.formGroup.get('borrowerCount').patchValue(individualCount);
  }

  public setBorrowingTypeFromAbn() {
    console.log('[setBorrowingTypeFromAbn]', this.selectedCompany);

    for (const type of this.borrowingTypes) {
      if (typeof type.ext.entityTypeInd !== 'undefined') {
        if (type.ext.entityTypeInd.includes(this.selectedCompany.entity.ind.toLowerCase())) {
          this.selectedType = type.id;
          this.formGroup.get('borrowerType').patchValue(type.id);
          break;
        } else {
          console.log('[setBorrowingTypeFromAbn]', 'no match');
        }
      }
    }
  }

  public emitBorrowerTypeChange(type, count) {
    if (!this.isLateInit) {
      console.log('Borrower Type has changed', type, count);
      if (type && type.id === 'individual') {
        count = 1;
      } else if (type && type.id === 'individual-with-non-applicant') {
        count = 2;
      }

      console.log('this.borrowingTypeChange', type, count);

      this.borrowingTypeChange.emit({
        borrowingType: type,
        borrowerCount: count
      });

      this.dataHandlerService.sendPersonListData(this.personList);
    }
  }

  public setBorrowerCountTriggers(borrowerType) {
    console.log('[setBorrowerCountTriggers]', borrowerType);
    this.selectedType = this.borrowingTypes.find((type) => borrowerType === type.id);

    console.log('this.selectedType', this.selectedType);
    if (this.selectedType && this.selectedType.ext && this.selectedType.ext.requireCount) {
      this.borrowerCountRequired = true;
      if (this.selectedType.ext.label) {
        this.countLabel = this.selectedType.ext.label;
      } else {
        this.countLabel = 'Borrower Count';
      }
    } else {
      this.borrowerCountRequired = false; // if borrowing count is not required, set the borrowing count to 1
      this.formGroup.get('borrowerCount').patchValue(this.formGroup.value.borrowerCount || 1);
    }
  }

  selectTrustACN(record) {
    console.log('[selectedTrustCompany]', record);
    // TODO: validate if has ACN?
    this.selectedTrustCompany.emit(record);
  }
}
